import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { useAppContext } from 'new-components/OpAppScaffold/components/AppContext';
import { getAppOrigin } from 'utils/getAppOrigin';

export const useNavigateToSos = (orgId: number) => {
  const { app } = useAppContext();
  const navigate = useNavigate();

  const handleNavigateToSos = useCallback(() => {
    if (app === 'sos') {
      navigate(0);
      return;
    }

    window.open(`${getAppOrigin('sos')}/o/${orgId}`, '_self');
  }, [app, navigate, orgId]);

  return {
    handleNavigateToSos,
  };
};
